import React, { useState, useCallback, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

import Loading from '../../components/Loading';
import axios from '../../services/axios';
import { useNotification } from '../../components/Notification/NotificationContext';
import Forms from '../../components/Forms';
import ErrorProcessor from '../../components/ErrorProcessor';

export default function CustomerAddr({ customer }) {
  const routeName = '/customeraddresses';
  const dataName = 'Cliente';
  const [apiErrors, setApiErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const notification = useNotification();
  const [customerEdit, setCustomer] = useState(customer);
  const [dataLoaded, setDataLoaded] = useState(false);

  const [formEditAddr, setFormEditAddr] = useState({
    street: '',
    complement: '',
    city: '',
    state: '',
    postal_code: '',
    country: '',
    description: '',
    customer_id: customerEdit.id,
  });

  const validationSchemaAddr = Yup.object().shape({
    postal_code: Yup.number()
      .typeError('Deve ser numérico')
      .min(7, 'CEP deve conter no mínimo 7 dígitos.')
      .required('CEP obrigatório.'),
    street: Yup.string().required('Logradouro obrigatório.'),
    number: Yup.number().typeError('Deve ser numérico'),
    complement: Yup.string(),
    city: Yup.string().required('Cidade / Município obrigatório.'),
    neighborhood: Yup.string().required('Bairro obrigatório.'),
    state: Yup.string().required('UF obrigatório.'),
    description: Yup.string().required('Descrição obrigatória.'),
  });
  const handleFieldChangeAddr = useCallback((fieldName, value) => {
    setFormEditAddr((prevValues) => ({ ...prevValues, [fieldName]: value }));
  }, []);

  const fieldsAddr = [
    {
      name: 'postal_code',
      id: 'postal_code',
      label: 'CEP',
      type: 'number',
      onChange: (e) => handleFieldChangeAddr('postal_code', e.target.value),
      colSize: 3,
      additionalProps: {},
      group: 'Endereço',
    },
    {
      name: 'street',
      id: 'street',
      label: 'Logradouro',
      type: 'text',
      onChange: (e) => handleFieldChangeAddr('street', e.target.value),
      colSize: 4,
      additionalProps: {},
      group: 'Endereço',
    },
    {
      name: 'number',
      id: 'number',
      label: 'Número',
      type: 'number',
      onChange: (e) => handleFieldChangeAddr('number', e.target.value),
      colSize: 2,
      additionalProps: {},
      group: 'Endereço',
    },
    {
      name: 'complement',
      id: 'complement',
      label: 'Complemento',
      type: 'text',
      onChange: (e) => handleFieldChangeAddr('complement', e.target.value),
      colSize: 3,
      additionalProps: {},
      group: 'Endereço',
    },
    {
      name: 'neighborhood',
      id: 'neighborhood',
      label: 'Bairro',
      type: 'text',
      onChange: (e) => handleFieldChangeAddr('neighborhood', e.target.value),
      colSize: 4,
      additionalProps: {},
      group: 'Endereço',
    },
    {
      name: 'city',
      id: 'city',
      label: 'Cidade / Município',
      type: 'text',
      onChange: (e) => handleFieldChangeAddr('city', e.target.value),
      colSize: 3,
      additionalProps: {},
      group: 'Endereço',
    },
    {
      name: 'state',
      id: 'state',
      label: 'UF',
      type: 'text',
      onChange: (e) => handleFieldChangeAddr('state', e.target.value),
      colSize: 2,
      additionalProps: {},
      group: 'Endereço',
    },
    {
      name: 'description',
      id: 'description',
      label: 'Descrição do endereço',
      type: 'text',
      onChange: (e) => handleFieldChangeAddr('description', e.target.value),
      colSize: 3,
      additionalProps: {},
      group: 'Endereço',
    },
  ];

  const getCustomer = useCallback(async () => {
    try {
      const request = await axios.get(`customers/${customerEdit.id}`);

      if (request.data.CustomerAddresses.length > 0) {
        setFormEditAddr({ ...request.data.CustomerAddresses[0] });
      }
      setCustomer(request.data);
    } catch (err) {
      setApiErrors(err);
    }
  }, [customerEdit]);

  const handleSubmitAddr = async () => {
    try {
      setIsLoading(true);
      let action = 'atualizado';
      if (formEditAddr.id) {
        await axios.put(`${routeName}/${formEditAddr.id}`, formEditAddr);
      } else {
        await axios.post(routeName, formEditAddr);
        action = 'cadastrado';
      }

      notification(`Endereço ${action} com sucesso`, 'success');
      await getCustomer();
    } catch (err) {
      setApiErrors(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (customerEdit.CustomerAddresses.length > 0) {
      setFormEditAddr({ ...customerEdit.CustomerAddresses[0] });
    }
    setDataLoaded(true);
  }, []);

  return (
    <Card className="mb-5">
      <Loading isLoading={isLoading} />
      <ErrorProcessor error={apiErrors} />
      <Card.Header>
        <h4 className="card-heading">Atualizar endereço do {dataName}</h4>
      </Card.Header>
      <Card.Body>
        {dataLoaded ? (
          <Forms
            initialValues={formEditAddr}
            validationSchema={validationSchemaAddr}
            onSubmit={handleSubmitAddr}
            fields={fieldsAddr}
            btnSubmit={{
              variant: 'primary',
              type: 'submit',
              text: 'Atualizar',
            }}
          />
        ) : null}
      </Card.Body>
    </Card>
  );
}

CustomerAddr.propTypes = {
  customer: PropTypes.shape({}).isRequired,
};
